import { type DealerApplication, type DealerApplicationState } from '@carsfinders/contracts';

import { apiFetch } from '../../lib/api';

/**
 * Admin dealer-review API (Phase 14 — B2B portal). Calls api-node directly:
 *   GET  /api/admin/dealer/applications?state=&limit=&offset=
 *   POST /api/admin/dealer/applications/:id/approve
 *   POST /api/admin/dealer/applications/:id/reject   { reason }
 */
export interface DealerApplicationsResponse {
	applications: DealerApplication[];
	count: number;
}

/**
 * Dealer applications. Omit `state` to read every status in one call — that is
 * what the review screen does, because the artboard prints a count on all four
 * filter tabs and a per-state query can only ever make one of them true.
 *
 * The parameter stays available for the dashboard's "KYB waiting" tile, which
 * asks for `pending` alone. `limit` is the API's ceiling (200).
 */
export function fetchDealerApplications(
	state?: DealerApplicationState,
): Promise<DealerApplicationsResponse> {
	return apiFetch<DealerApplicationsResponse>('admin/dealer/applications', {
		searchParams: { state, limit: '200' },
	});
}

export function approveDealerApplication(id: string): Promise<{ success?: boolean }> {
	return apiFetch(`admin/dealer/applications/${id}/approve`, { method: 'POST' });
}

export function rejectDealerApplication(
	id: string,
	reason: string,
): Promise<{ success?: boolean }> {
	return apiFetch(`admin/dealer/applications/${id}/reject`, {
		method: 'POST',
		body: { reason },
	});
}
